import { render, staticRenderFns } from "./Actors.vue?vue&type=template&id=0f9ee3a9&"
import script from "./Actors.vue?vue&type=script&lang=js&"
export * from "./Actors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports